import { useTranslation } from 'react-i18next';

import { ConfirmModal } from '@/components/feedback/ConfirmModal';

interface SeedEditWarningModalProps {
  open: boolean;
  roleName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function SeedEditWarningModal({
  open,
  roleName,
  onConfirm,
  onCancel,
}: SeedEditWarningModalProps) {
  const { t } = useTranslation('roles');
  return (
    <ConfirmModal
      open={open}
      title={t('modals.seedEdit.title')}
      message={t('modals.seedEdit.message', { name: roleName })}
      confirmLabel={t('actions.continue')}
      cancelLabel={t('actions.cancel')}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
